import React from 'react';
import { FadeInSection, Divider, CTAButton } from './ui';
import { BookOpen, CheckCircle2, ShieldCheck, Droplets, Shield, Sparkles } from 'lucide-react';
export const Solution = () => {
  return <div className="bg-brand-cream" data-id="element-210">
      {/* SECCIÓN 5: REVELACIÓN DEL MECANISMO */}
      <section className="py-20 px-4 bg-white border-y border-brand-creamDark" data-id="element-211">
        <div className="max-w-5xl mx-auto" data-id="element-212">
          <FadeInSection data-id="element-213">
            <div className="text-center mb-16" data-id="element-214">
              <div className="inline-flex items-center justify-center space-x-2 bg-brand-copper/10 text-brand-copper px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider mb-6" data-id="element-215">
                <Sparkles size={16} data-id="element-216" />
                <span data-id="element-217">La Ciencia del Rescate</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-playfair font-bold text-brand-brown mb-4" data-id="element-218">
                EL MÉTODO CAPA SOBRE CAPA
              </h2>
              <p className="text-xl text-brand-brown/70 italic font-playfair" data-id="element-219">
                El sistema de reconstrucción en 3 etapas que cambia todo
              </p>
            </div>

            <p className="text-lg text-center max-w-3xl mx-auto mb-16 text-brand-brown/80" data-id="element-220">
              La fibra capilar dañada por químicos pierde su estructura en tres
              capas simultáneamente. La mayoría de los tratamientos atacan solo
              una, o dos en el orden equivocado.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-221">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-creamDark -z-10" data-id="element-222"></div>

              {/* Step 1 */}
              <div className="bg-brand-cream p-8 rounded-2xl border border-brand-copper/20 relative flex flex-col items-center text-center shadow-lg shadow-brand-brown/5" data-id="element-223">
                <div className="w-16 h-16 bg-brand-brown text-brand-cream rounded-full flex items-center justify-center text-2xl font-bold mb-6 border-4 border-white shadow-md" data-id="element-224">
                  1
                </div>
                <h3 className="text-2xl font-playfair font-bold text-brand-copper mb-4 flex items-center gap-2" data-id="element-225">
                  <Shield size={24} data-id="element-226" /> PROTEÍNA
                </h3>
                <p className="text-brand-brown/80" data-id="element-227">
                  La estructura interna se debilita. Sin proteína, el cabello es
                  flexible pero sin fuerza. Se estira y no regresa. Se siente
                  chicloso.
                </p>
              </div>

              {/* Step 2 */}
              <div className="bg-brand-cream p-8 rounded-2xl border border-brand-copper/20 relative flex flex-col items-center text-center shadow-lg shadow-brand-brown/5" data-id="element-228">
                <div className="w-16 h-16 bg-brand-brown text-brand-cream rounded-full flex items-center justify-center text-2xl font-bold mb-6 border-4 border-white shadow-md" data-id="element-229">
                  2
                </div>
                <h3 className="text-2xl font-playfair font-bold text-brand-copper mb-4 flex items-center gap-2" data-id="element-230">
                  <Droplets size={24} data-id="element-231" /> HIDRATACIÓN
                </h3>
                <p className="text-brand-brown/80" data-id="element-232">
                  La fibra pierde agua y elasticidad. Sin hidratación, el
                  cabello se vuelve áspero, opaco y quebradizo.
                </p>
              </div>

              {/* Step 3 */}
              <div className="bg-brand-cream p-8 rounded-2xl border border-brand-copper/20 relative flex flex-col items-center text-center shadow-lg shadow-brand-brown/5" data-id="element-233">
                <div className="w-16 h-16 bg-brand-brown text-brand-cream rounded-full flex items-center justify-center text-2xl font-bold mb-6 border-4 border-white shadow-md" data-id="element-234">
                  3
                </div>
                <h3 className="text-2xl font-playfair font-bold text-brand-copper mb-4 flex items-center gap-2" data-id="element-235">
                  <ShieldCheck size={24} data-id="element-236" /> SELLADO
                </h3>
                <p className="text-brand-brown/80" data-id="element-237">
                  La cutícula queda abierta. Sin sellado, todo lo que pusiste —
                  proteína e hidratación — se escapa en el primer lavado.
                </p>
              </div>
            </div>

            <div className="mt-16 bg-brand-brown text-brand-cream p-8 md:p-12 rounded-2xl text-center shadow-xl" data-id="element-238">
              <p className="text-xl md:text-2xl font-playfair leading-relaxed" data-id="element-239">
                El Método Capa sobre Capa trabaja las tres, en la secuencia
                exacta en que la fibra capilar puede recibirlas y retenerlas.
                <br data-id="element-240" />
                <br data-id="element-241" />
                <strong className="text-brand-copperLight text-2xl md:text-3xl" data-id="element-242">
                  Primero reconstruyes. Luego hidratas. Luego sellas.
                </strong>
              </p>
              <p className="mt-6 text-lg text-brand-cream/80" data-id="element-243">
                En ese orden. Con esa lógica. Con productos que ya existen en
                cualquier farmacia de Latinoamérica.
                <br data-id="element-244" />
                <span className="font-bold text-white mt-2 block" data-id="element-245">
                  Eso es todo lo que hacía falta. Y nunca te lo habían dado
                  junto.
                </span>
              </p>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECCIÓN 6: PRESENTACIÓN DEL PRODUCTO */}
      <section className="py-24 px-4 max-w-5xl mx-auto" data-id="element-246">
        <FadeInSection data-id="element-247">
          <div className="text-center mb-16" data-id="element-248">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-4" data-id="element-249">
              Presentando
            </h2>
            <h3 className="text-4xl md:text-6xl font-playfair font-bold text-brand-brown mb-6" data-id="element-250">
              S.O.S. Rescate Capilar
              <br data-id="element-251" />
              Post-Químicos
            </h3>
            <p className="text-xl text-brand-brown/80 max-w-3xl mx-auto italic" data-id="element-252">
              El eBook que te guía paso a paso durante 7 días para recuperar tu
              cabello chicloso o quemado — desde casa, con productos accesibles.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-brand-creamDark" data-id="element-253">
            <div className="p-8 md:p-12 bg-brand-creamDark/30 border-b border-brand-creamDark" data-id="element-254">
              <p className="text-lg text-brand-brown/80 text-center max-w-3xl mx-auto" data-id="element-255">
                Este no es un libro de recetas capilares genéricas. Es un{' '}
                <strong data-id="element-256">protocolo de emergencia estructurado</strong>, diseñado
                específicamente para mujeres cuyo cabello fue dañado por
                procesos químicos y que necesitan resultados reales, visibles, y
                rápidos.
              </p>
            </div>

            <div className="p-8 md:p-12" data-id="element-257">
              <h4 className="text-2xl font-playfair font-bold mb-8 text-center" data-id="element-258">
                Lo que encontrarás dentro:
              </h4>

              <div className="space-y-4" data-id="element-259">
                {[{
                cap: 'Cap. 1',
                title: 'Diagnóstico rápido',
                desc: 'Qué es el cabello chicloso, niveles de daño 1-5, mitos comunes.',
                why: 'Sabrás exactamente dónde está tu cabello y qué necesita — no al azar.'
              }, {
                cap: 'Cap. 2',
                title: 'Los 3 niveles de reconstrucción',
                desc: 'Proteína, Hidratación, Sellado.',
                why: 'Entenderás el sistema completo por primera vez.'
              }, {
                cap: 'Cap. 3',
                title: 'Método Capa sobre Capa paso a paso',
                desc: 'El corazón del protocolo.',
                why: 'La hoja de ruta que lo cambia todo.'
              }, {
                cap: 'Cap. 4',
                title: 'Kit S.O.S.',
                desc: 'Productos del supermercado y farmacia que funcionan.',
                why: 'Sin gastar en marcas caras ni buscar cosas raras.'
              }, {
                cap: 'Cap. 5',
                title: 'Rutina de 7 días',
                desc: 'Guía diaria detallada.',
                why: 'Exactamente qué hacer cada día, sin adivinar.'
              }, {
                cap: 'Cap. 6',
                title: 'Mantenimiento y prevención futura',
                desc: 'Cuidados a largo plazo.',
                why: 'Para que el daño no vuelva — y el resultado dure.'
              }].map((item, i) => <div key={i} className="flex flex-col md:flex-row gap-4 p-4 rounded-xl hover:bg-brand-cream transition-colors border border-transparent hover:border-brand-copper/20" data-id="element-260">
                    <div className="md:w-1/4 font-bold text-brand-copper shrink-0" data-id="element-261">
                      {item.cap}
                    </div>
                    <div className="md:w-1/3 font-bold text-brand-brown" data-id="element-262">
                      {item.title}
                    </div>
                    <div className="md:w-5/12 text-brand-brown/70 text-sm" data-id="element-263">
                      {item.why}
                    </div>
                  </div>)}

                <div className="mt-8 p-6 bg-brand-copper/10 rounded-xl border border-brand-copper/30 space-y-4" data-id="element-264">
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-265">
                    <div className="md:w-1/4 font-bold text-brand-red flex items-center gap-2" data-id="element-266">
                      <Sparkles size={16} data-id="element-267" /> BONO 1
                    </div>
                    <div className="md:w-1/3 font-bold text-brand-brown" data-id="element-268">
                      Mini-guía de Peinados Protectores
                    </div>
                    <div className="md:w-5/12 text-brand-brown/70 text-sm" data-id="element-269">
                      Cuida tu cabello mientras se recupera.
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-270">
                    <div className="md:w-1/4 font-bold text-brand-red flex items-center gap-2" data-id="element-271">
                      <Sparkles size={16} data-id="element-272" /> BONO 2
                    </div>
                    <div className="md:w-1/3 font-bold text-brand-brown" data-id="element-273">
                      Tabla de Productos Económicos vs. Premium
                    </div>
                    <div className="md:w-5/12 text-brand-brown/70 text-sm" data-id="element-274">
                      Elige sin confusión, compra sin error.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-275">
            <CTAButton text="QUIERO EL PROTOCOLO COMPLETO" data-id="element-276" />
          </div>
        </FadeInSection>
      </section>

      <Divider data-id="element-277" />

      {/* SECCIÓN 7: HISTORIA DE ORIGEN */}
      <section className="py-16 px-4 max-w-3xl mx-auto text-center" data-id="element-278">
        <FadeInSection data-id="element-279">
          <BookOpen className="w-12 h-12 text-brand-copper mx-auto mb-6 opacity-50" data-id="element-280" />
          <div className="space-y-6 text-lg text-brand-brown/80 leading-relaxed" data-id="element-281">
            <p data-id="element-282">Este protocolo no nació en un laboratorio.</p>
            <p data-id="element-283">
              Nació de la desesperación de ver un cabello destruido en el espejo
              — y decidir que tenía que existir una forma sistemática de
              recuperarlo.
            </p>
            <p data-id="element-284">
              Nació de horas de investigación sobre química capilar, de leer
              etiquetas, de entender qué hace cada ingrediente en cada capa de
              la fibra. De probar. De ajustar. De documentar qué funcionaba y en
              qué orden.
            </p>
            <p data-id="element-285">
              Y nació de la convicción de que las mujeres en Latinoamérica no
              deberían tener que gastar una fortuna en el salón, ni resignarse a
              cortar su cabello, ni seguir viendo videos contradictorios sin
              estructura, para poder recuperar algo tan básico como sentirse
              bien con su propio cabello.
            </p>
            <p className="font-playfair font-bold text-2xl text-brand-brown mt-8" data-id="element-286">
              Este eBook es lo que hubiera querido tener desde el principio.
              <br data-id="element-287" />
              <span className="text-brand-copper" data-id="element-288">Y ahora es tuyo.</span>
            </p>
          </div>
        </FadeInSection>
      </section>

      {/* SECCIÓN 8: BENEFICIOS COMO RESULTADOS DE VIDA */}
      <section className="py-20 px-4 bg-white" data-id="element-289">
        <div className="max-w-5xl mx-auto" data-id="element-290">
          <FadeInSection data-id="element-291">
            <h2 className="text-3xl md:text-4xl font-playfair font-bold text-center mb-16 text-brand-brown" data-id="element-292">
              Lo que cambia cuando usas S.O.S. Rescate Capilar
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-293">
              {[{
              feat: 'Diagnóstico claro de tu nivel de daño',
              ben: 'Dejas de aplicar cosas al azar y empiezas a saber exactamente qué necesitas.'
            }, {
              feat: 'Protocolo de 7 días estructurado',
              ben: 'Cada día sabes qué hacer — no hay más parálisis ni confusión.'
            }, {
              feat: 'Productos de supermercado y farmacia',
              ben: 'No necesitas pedir nada online ni gastar en marcas caras.'
            }, {
              feat: 'Método Capa sobre Capa',
              ben: 'Por primera vez, tratas el cabello en el orden correcto y los resultados se mantienen.'
            }, {
              feat: 'Rutina de mantenimiento post-rescate',
              ben: 'El daño no vuelve — el cabello que recuperas, lo conservas.'
            }, {
              feat: 'Peinados protectores',
              ben: 'Puedes verte bien incluso mientras el cabello se está restaurando.'
            }].map((item, i) => <div key={i} className="flex gap-4 items-start" data-id="element-294">
                  <CheckCircle2 className="w-6 h-6 text-brand-copper shrink-0 mt-1" data-id="element-295" />
                  <div data-id="element-296">
                    <h4 className="font-bold text-brand-brown mb-1" data-id="element-297">
                      {item.feat}
                    </h4>
                    <p className="text-brand-brown/70" data-id="element-298">{item.ben}</p>
                  </div>
                </div>)}
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECCIÓN 9: CAPAS DE PRUEBA */}
      <section className="py-20 px-4 bg-brand-brown text-brand-cream text-center" data-id="element-299">
        <div className="max-w-4xl mx-auto" data-id="element-300">
          <FadeInSection data-id="element-301">
            <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-10 text-brand-copperLight" data-id="element-302">
              Esto funciona porque la ciencia lo respalda.
            </h2>

            <div className="space-y-8 text-lg text-brand-cream/80 leading-relaxed text-left md:text-center" data-id="element-303">
              <p data-id="element-304">
                <strong className="text-white" data-id="element-305">
                  La reconstrucción capilar en tres etapas
                </strong>{' '}
                (proteína, hidratación, sellado) es un principio reconocido en
                tricología y cuidado capilar profesional. No es una tendencia de
                redes sociales. Es la misma lógica que usan los tratamientos de
                salones de alta gama — solo que aquí te la enseñamos de forma
                accesible, en casa, con productos reales.
              </p>
              <p data-id="element-306">
                <strong className="text-white" data-id="element-307">
                  El diagnóstico por niveles de daño (Escala 1-5)
                </strong>{' '}
                te permite personalizar el protocolo a tu situación específica —
                porque no todos los cabellos dañados están igual, y tratar un
                Nivel 2 como un Nivel 5 puede hacer más daño que bien.
              </p>
              <p data-id="element-308">
                <strong className="text-white" data-id="element-309">
                  Los resultados en 7 días son posibles
                </strong>{' '}
                porque el protocolo actúa desde el primer día en la capa más
                urgente. No es una promesa vacía — es una consecuencia lógica de
                aplicar el sistema correcto en el orden correcto.
              </p>
            </div>
          </FadeInSection>
        </div>
      </section>
    </div>;
};